import axios from 'axios';

(function extractCodeFromUrl() {
  const url = new URL(window.location.href);
  const authCode = url.searchParams.get('code');

  if (authCode) {
    localStorage.setItem('oauth_code', authCode);
    console.log('已保存 code 到 localStorage:', authCode);

    const existingUsername = localStorage.getItem('comUsername');
    if (
      !existingUsername ||
      existingUsername.trim() === '' ||
      existingUsername.startsWith('errmsg')
    ) {
      // 发起请求，并在完成后跳转
      axios.get('http://xzs.lbzuche.cn:8181/getmyname', { params: { action: 'get', authCode } })
        .then(response => {
          console.log('get getmyname:', authCode);
          if (response.data) {
            console.log('getmyname:', response.data);
            localStorage.setItem('comUsername', response.data);
            localStorage.setItem('authCompleted', 'true');
          }
        })
        .catch(err => {
          console.error('后端错误:', err);
        })
        .finally(() => {
          // 无论成功失败，都跳转（避免 code 留在 URL）
          const cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
          window.location.replace(cleanUrl);
        });
    } else {
      localStorage.setItem('authCompleted', 'true');
      console.log('comUsername 已存在，跳过请求:', existingUsername);
      // 这里也需要跳转
      const cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
      window.location.replace(cleanUrl);
    }
  } else {
    console.log('当前页面已是干净URL，无需跳转处理');
  }
})();




import { createApp } from 'vue'
import App from './App.vue'


createApp(App).mount('#app')
